import React from "react";
import Accordion from "react-bootstrap/Accordion";

// Estilos base
const actividadStyle = {
  backgroundColor: "#294235",
  padding: "40px",
  borderRadius: "20px",
  width: "420px",
  flexShrink: 0,
  boxShadow: "0 8px 24px rgba(0, 0, 0, 0.2)",
};

const tituloStyle = {
  fontWeight: "bold",
  letterSpacing: "1px",
};

export default function PrimariaActividades() {
  return (
    <section className="my-12">
      {/* Título general */}
      <h2
        className="text-center mb-9"
        style={{
          fontSize: "2rem",
          fontWeight: "bold",
          letterSpacing: "2px",
          color: "#005818",
          background: "#ffffff",
        }}
      >
        PRIMARIA
      </h2>

      {/* Acordeón con actividades */}
      <Accordion alwaysOpen defaultActiveKey="0">
        <Accordion.Item eventKey="0">
          <Accordion.Header>Actividades de 1ro a 6to grado</Accordion.Header>
          <Accordion.Body>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "30px",
                overflowX: "auto",
                padding: "20px 0",
                flexWrap: "wrap",
              }}
            >
              {/* Curricular */}
              <div style={actividadStyle}>
                <h2 className="text-white text-center mb-4" style={tituloStyle}>
                  Curricular
                </h2>
                <p className="text-white mb-2 text-center" style={{ lineHeight: "1.6" }}>
                  <span className="font-semibold">1ro a 3ro grado</span>
                </p>
                <p className="text-white" style={{ lineHeight: "1.8" }}>
                  Durante el año, los estudiantes practican disciplinas deportivas
                  variadas en clases regulares.
                </p>
              </div>

              {/* Extracurricular */}
              <div style={actividadStyle}>
                <h2 className="text-white text-center mb-4" style={tituloStyle}>
                  Extracurricular
                </h2>
                <p className="text-white mb-2 text-center" style={{ lineHeight: "1.6" }}>
                  <span className="font-semibold">4to a 6to grado</span>
                </p>
                <p className="text-white" style={{ lineHeight: "1.8" }}>
                  Se realizan diferentes deportes, incluyendo fútbol, handball,
                  vóley, básquet.
                </p>
              </div>
            </div>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </section>
  );
}
